import React, { Fragment } from 'react';
import { Redirect, useHistory } from 'react-router';
import TextInput from '../NewContact/TextInput';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './signupPage.css';
import { useState } from 'react';
import Dropdown from '../shared/Dropdown';
import TermsPopup from './TermsPopup';
import DownloadApp from './DownloadApp';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import TorontoFooter from '../Layout/TorontoFooter';
import Verification from './Verfication';
import { useEffect } from 'react';

const NewSignUp = ({
  country,
  client,
  city,
  refCode,
  accessibleCities
}) => {
  const [curFirst, setCurFirst] = useState();
  const [curLast, setCurLast] = useState();
  const [curEmail, setCurEmail] = useState();
  const [curPassword, setCurPassword] = useState();
  const [curPhone, setCurPhone] = useState();
  const [curDrive, setCurDrive] = useState();
  const [curHear, setCurHear] = useState(refCode ? 'Referral' : undefined);
  const [curCode, setCurCode] = useState(refCode ? refCode : undefined);
  const [curOther, setCurOther] = useState();
  const [isTerms, setIsTerms] = useState();
  const [toValidate, setToValidate] = useState(false);
  const [validated, setValidated] = useState();
  const [errorFields, setErrorFields] = useState([]);
  const [passwordType, setPasswordType] = useState('password');
  const [invalidPhoneInput, setInvalidPhoneInput] = useState(false);
  const [returnedAuthyId, setAuthyId] = useState();
  const [isEye, setIsEye] = useState(false);

  const triggerFirst = e => {
    setCurFirst(e.target.value);
  };
  const triggerLast = e => {
    setCurLast(e.target.value);
  };
  const triggerEmail = e => {
    setCurEmail(e.target.value);
  };
  const triggerPassword = e => {
    setCurPassword(e.target.value);
  };
  const triggerCode = e => {
    setCurCode(e.target.value);
  };
  const triggerOther = e => {
    setCurOther(e.target.value);
  };
  const triggerPhone = e => {
    setCurPhone(e);
  };

  const allCityOptions = accessibleCities
    ? accessibleCities.map(city => {
        return {
          name: city.name,
          value: city.id
        };
      })
    : [];

  const triggerDriveCity = childData => {
    setCurDrive(childData);
  };

  const allHearOptions = [
    { name: 'Google', value: 'Google' },
    { name: 'Referral', value: 'Referral' },
    { name: 'Saw an Autzu vehicle', value: 'Saw an Autzu vehicle' },
    { name: 'Advertisement', value: 'Advertisement' },
    { name: 'Uber Greenlight Hub', value: 'Uber Greenlight Hub' },
    {
      name: 'Uber Vehicle Marketplace',
      value: 'Uber Vehicle Marketplace'
    },
    { name: 'Facebook', value: 'Facebook' },
    { name: 'Instagram', value: 'Instagram' },
    { name: 'TikTok', value: 'TikTok' },
    { name: 'Other', value: 'Other' }
  ];
  const triggerHearFrom = childData => {
    setCurHear(childData);
  };

  const toggleTerms = () => {
    setIsTerms(!isTerms);
  };

  const toggleValidated = () => {
    setValidated(!validated);
  };
  const toggleToValidate = () => {
    setToValidate(true);
  };

  const toggleEye = () => {
    setIsEye(!isEye);
    if (passwordType === 'password') {
      setPasswordType('text');
    } else {
      setPasswordType('password');
    }
  };

  useEffect(() => {
    if (curPhone && curPhone.length !== 11) {
      setInvalidPhoneInput(true);
    } else {
      setInvalidPhoneInput(false);
    }
  }, [curPhone]);

  const SEND_VERIFICATION = gql`
    mutation SendVerificationCode(
      $countryCode: String!
      $mobile: String!
      $email: String!
    ) {
      sendVerificationCode(
        countryCode: $countryCode
        mobile: $mobile
        email: $email
      ) {
        sent
        error
        authyId
      }
    }
  `;

  const handleSendVerification = () => {
    // e.preventDefault();
    client
      .mutate({
        mutation: SEND_VERIFICATION,
        variables: {
          countryCode: '1',
          mobile: curPhone,
          email: curEmail
        }
      })
      .then(res => {
        console.log(res.data);
        if (res.data.sendVerificationCode.sent) {
          setAuthyId(res.data.sendVerificationCode.authyId);
          console.log('sms verification code sent');
        } else if (res.data.error) {
          console.log('send verification error!');
        }
      });
  };

  const FORM_VALIDATION = gql`
    mutation FormValidation($email: String!, $mobile: String!) {
      formValidation(email: $email, mobile: $mobile) {
        valid
        invalidFields
      }
    }
  `;

  const handleValidation = () => {
    // e.preventDefault();
    client
      .mutate({
        mutation: FORM_VALIDATION,
        variables: {
          email: curEmail,
          mobile: curPhone
        }
      })
      .then(res => {
        if (!res.data.formValidation.valid) {
          setErrorFields(res.data.formValidation.invalidFields);
        } else {
          setErrorFields([]);
          handleSendVerification();
          toggleValidated();
        }
      });
  };

  const isMobile = window.innerWidth < 768;
  const notAllFilled =
    !curFirst ||
    !curLast ||
    !curEmail ||
    !curEmail.includes('@') ||
    !curPhone ||
    !curPassword ||
    !curDrive ||
    !curHear ||
    (curHear === 'Referral' && !curCode) ||
    (curHear === 'Other' && !curOther);

  return validated ? (
    <Fragment>
      <Verification
        curPhone={curPhone}
        country={country}
        authyId={returnedAuthyId}
        toggleValidated={toggleValidated}
        curFirst={curFirst}
        curLast={curLast}
        curEmail={curEmail}
        curPassword={curPassword}
        curDrive={curDrive}
        curHear={curHear}
        curCode={curCode}
        curOther={curOther}
      />
      <TorontoFooter />
    </Fragment>
  ) : (
    <Fragment>
      <div className="signup-form-container">
        <div className="form-title">Sign up</div>
        <div className="input-field">
          <div className="floating-label">First name</div>
          <input
            className={
              toValidate
                ? curFirst !== '' && curFirst
                  ? 'input-container'
                  : 'input-container-empty'
                : 'input-container'
            }
            onChange={triggerFirst}></input>
          {toValidate && (curFirst === '' || !curFirst) && (
            <div style={{ color: '#ff0000' }}>Cannot be empty</div>
          )}
        </div>
        <div className="input-field">
          <div className="floating-label">Last name</div>
          <input
            className={
              toValidate
                ? curLast !== '' && curLast
                  ? 'input-container'
                  : 'input-container-empty'
                : 'input-container'
            }
            onChange={triggerLast}></input>
          {toValidate && (curLast === '' || !curLast) && (
            <span style={{ color: '#ff0000' }}>Cannot be empty</span>
          )}
        </div>
        <div className="floating-label">Phone number</div>
        <PhoneInput
          value={curPhone}
          onChange={triggerPhone}
          country={country === 'CA' ? 'ca' : 'us'}
          className={
            toValidate
              ? curPhone !== '' &&
                curPhone &&
                !errorFields.includes('mobile')
                ? 'input-field-phone'
                : 'input-field-phone-empty'
              : invalidPhoneInput
              ? 'input-field-phone-empty'
              : 'input-field-phone'
          }
          inputStyle={{
            height: '40px',
            width: '100%',
            border: toValidate
              ? curPhone !== '' && curPhone
                ? '1px solid #dedede'
                : '1px solid #ff0000'
              : '1px solid #dedede'
          }}
        />
        {toValidate && (curPhone === '' || !curPhone) && (
          <span style={{ color: '#ff0000', marginBottom: '24px' }}>
            Cannot be empty
          </span>
        )}
        {invalidPhoneInput && (
          <span style={{ color: '#ff0000', marginBottom: '24px' }}>
            Invalid phone number
          </span>
        )}
        {errorFields.includes('mobile') && (
          <span style={{ color: '#ff0000', marginBottom: '24px' }}>
            Phone number already exists
          </span>
        )}
        <div className="input-field">
          <div className="floating-label">Email address</div>
          <input
            className={
              toValidate
                ? curEmail !== '' && curEmail
                  ? 'input-container'
                  : 'input-container-empty'
                : 'input-container'
            }
            pattern="[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}"
            onChange={triggerEmail}></input>
          {toValidate && (curEmail === '' || !curEmail) && (
            <span style={{ color: '#ff0000' }}>Cannot be empty</span>
          )}
          {toValidate && curEmail && !curEmail.includes('@') && (
            <span style={{ color: '#ff0000' }}>Invalid email address</span>
          )}
          {errorFields.includes('email') && (
            <span style={{ color: '#ff0000' }}>Email already exists</span>
          )}
        </div>
        <div className="input-field">
          <div className="floating-label">Set password</div>
          <input
            className={
              toValidate
                ? curPassword !== '' && curPassword
                  ? 'input-container'
                  : 'input-container-empty'
                : 'input-container'
            }
            minLength="6"
            type={passwordType}
            placeholder="6 characters at least"
            onChange={triggerPassword}
            name="password"></input>
          <i
            onClick={toggleEye}
            className={`fa ${isEye ? 'fa-eye' : 'fa-eye-slash'}`}
            style={{
              cursor: 'pointer',
              position: 'relative',
              display: 'flex',
              paddingRight: '12px',
              left: isMobile ? '300px' : '570px',
              bottom: '25px',
              width: '20px'
            }}></i>
          {toValidate && (curPassword === '' || !curPassword) && (
            <span style={{ color: '#ff0000' }}>Cannot be empty</span>
          )}
        </div>
        <div className="input-field">
          <div className="floating-label" style={{ marginBottom: '0' }}>
            City you want to drive in
          </div>
          <Dropdown
            initialValue={curDrive}
            items={allCityOptions}
            onChange={triggerDriveCity}
            width={isMobile ? '327px' : '600px'}
            height="40px"
            optionWidth={isMobile ? '327px' : '600px'}
            borderColor={
              toValidate
                ? curDrive !== '' && curDrive
                  ? '#dedede'
                  : '#ff0000'
                : '#dedede'
            }
          />
          {toValidate && (curDrive === '' || !curDrive) && (
            <span style={{ color: '#ff0000' }}>No selection</span>
          )}
        </div>
        <div className="input-field">
          <div className="floating-label" style={{ marginBottom: '0' }}>
            How did you hear about Autzu?
          </div>
          <Dropdown
            initialValue={curHear}
            items={allHearOptions}
            onChange={triggerHearFrom}
            width={isMobile ? '327px' : '600px'}
            height="40px"
            optionWidth={isMobile ? '327px' : '600px'}
            borderColor={
              toValidate
                ? curHear !== '' && curHear
                  ? '#dedede'
                  : '#ff0000'
                : '#dedede'
            }
          />
          {toValidate && (curHear === '' || !curHear) && (
            <span style={{ color: '#ff0000' }}>No selection</span>
          )}
        </div>
        {curHear === 'Referral' && (
          <div className="input-field">
            <div className="floating-label">Referral code</div>
            <input
              className={
                toValidate
                  ? curCode !== '' && curCode
                    ? 'input-container'
                    : 'input-container-empty'
                  : 'input-container'
              }
              onChange={triggerCode}
              value={curCode}></input>
            {toValidate && (curCode === '' || !curCode) && (
              <span style={{ color: '#ff0000' }}>Cannot be empty</span>
            )}
          </div>
        )}
        {curHear === 'Other' && (
          <div className="input-field">
            <div className="floating-label">Other</div>
            <input
              className={
                toValidate
                  ? curOther !== '' && curOther
                    ? 'input-container'
                    : 'input-container-empty'
                  : 'input-container'
              }
              onChange={triggerOther}></input>
            {toValidate && (curOther === '' || !curOther) && (
              <span style={{ color: '#ff0000' }}>Cannot be empty</span>
            )}
          </div>
        )}
        <div>
          By selecting Agree and continue below, I agree to Autzu's{' '}
          <span
            style={{
              color: '#128dff',
              textDecoration: 'none',
              fontWeight: '600',
              cursor: 'pointer'
            }}
            onClick={toggleTerms}>
            Terms and Conditions
          </span>
        </div>
        <button
          className="signup-button"
          onClick={() => {
            toggleToValidate();
            !notAllFilled && handleValidation();
            // toggleValidated();
          }}>
          Agree and continue
        </button>
      </div>
      <TermsPopup open={isTerms} toggleTerms={toggleTerms} />
      <TorontoFooter />
    </Fragment>
  );
};

export default withApollo(NewSignUp);



// WEBPACK FOOTER //
// ./src/components/NewSignUp/index.js